
import {getFontEmbedCSS} from 'html-to-image'
import Widget from './widget.vue'

export default {
  components: {Widget},
  inject: {
    di_widgets: {default: () => []}
  },
  props: {
    href: {type: String, default: ''},
    snapshot: {type: Boolean, default: false},
    widgets: {type: Array, default: () => []} // for screenshots
  },
  computed: {
    widget_idxs() {
      return (this.href || '')
        .replace('widgets://', '')
        .split(',')
        .map(index => Number(index))
        .filter(index => Number.isInteger(index) && index >= 0)
    },
    rendered_widgets() {
      if (this.widgets.length) return this.widgets
      return this.widget_idxs
        .map(index => this.di_widgets[index])
        .filter(Boolean)
    },
    widget_groups() {
      const groups = []
      for (const widget of this.rendered_widgets) {
        const type = widget.type
        let group = groups.at(-1)
        if (!group || group.type !== type) {
          group = {key: groups.length, type, widgets: []}
          groups.push(group)
        }
        group.widgets.push(widget)
      }
      return groups
    }
  },
  methods: {
    async getImages() {
      const widgets = Array.isArray(this.$refs.widget)
        ? this.$refs.widget
        : [this.$refs.widget].filter(Boolean)
      if (!widgets.length) return []
      const font_embed = await getFontEmbedCSS(widgets[0].$el)
      const results = await Promise.allSettled(widgets.map(widget => widget.getImage(font_embed)))
      return results
        .filter(result => result.status === 'fulfilled')
        .map(result => result.value)
    }
  }
}
